<template>
  <div>
    <router-view
      v-if="item.id"
      :item="item"
      :item_saved="item_saved"
      @update="update"
    />
  </div>
</template>
<script>
import Api from '@/api/LeadMask.js'
import {updateMixin} from '@/components/mixins/Update'
import OrganizationApi from '@/api/Organization.js'
import PageTabs from '@/components/helpers/Layout/PageTabs'
import PageSaver from '@/components/helpers/Layout/PageSaver'
import Ui from '@/classes/Ui'
import Permission from '@/classes/Permission'

import Editor from '@/components/pages/lead_masks/LeadMaskEditor'

let tabs = [
  {name: 'lead_mask_editor'},
  {name: 'lead_mask_options'},
]
export default {
  components: {
    PageTabs,
    PageSaver,
    Editor
  },
  mixins: [updateMixin],
  data(){
    return {
      tabs,
      model: "lead_masks",
      api: new Api(),
      organizations: [],
      isRawDisplayed: false,
      item_saved: {}
    }
  },
  computed: {
    structure(){
      return JSON.stringify(this.item.structure)
    },
  },
  beforeRouteUpdate(to, from, next) {
    // necessary as otherwise the redirect in created() would trigger again
    if (to.name === 'lead_mask_edit') {
      this.$router.push({
        name: 'lead_masks'
      })
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('RESET_DRAG_EDITOR')
    this.$store.commit('SET_HEADER_COMPRESSED', false)
    next()
  },
  created() {
    // Navigate to editor directly
    if (this.$route.name === 'lead_mask_edit') {
      this.$router.push({
        name: 'lead_mask_editor'
      })
    }
  },
  mounted(){
    this.$store.commit('SET_ACTIVE_TAB', this.tabs[0].name)
    this.$store.commit('SET_HEADER_COMPRESSED', true)
    this.retrieve_organizations()
    Ui.setSecondaryHeaderTabs(this.tabs)
    Ui.setPageLevel(3)
    Ui.setSubtitle({link: {name: 'lead_masks'}})
  },
  beforeDestroy(){
    this.$store.commit('EMPTY_TABS')
    this.$store.commit('EMPTY_NOTIFICATION')
    this.$store.commit('SET_SECONDARY_HEADER_TABS', [])
  },
  methods: {
    newLeadMaskPath(){
      return this.$route.path === '/lead_mask/new'
    },
    retrieve_organizations(){
      let permission = Permission.loadPermissions()
      if (Permission.can(permission, 'organizations.list')) {
        let api = new OrganizationApi()
        api.all_for_association().then((items) => {
          this.organizations = items
        }).catch(function(error) {
          console.log(error)
        })
      }
    },
    changeTab(name){
      this.currentTab = name
    },
    structureChange(val){
      try {
        this.item.structure = JSON.parse(val)
        this.errors = []
      } catch(e) {
        this.errors.push({code: "lead_mask.json.invalid", field_name: "structure"})
      }
    },
    afterRetrieve(){
      this.item_saved = _.clone(this.item)
    },
    update(item) {
      if (!item) {
        item = this.item
      }
      this.api.post(item).then((item) => {
        this.item = item
        this.item_saved = _.clone(item)
        this.errors = []
        this.$store.commit('SET_NOTIFICATION', {
          'title': 'models.' + this.singular_model + '.message.' + this.type,
          'type': 'success'
        })
        EventBus.$emit('lead_mask_update', this.item)
      }).catch((e) => {
        console.error('err:', JSON.stringify(e))
        if (e.response) {
          this.errors = e.response.data.errors
          this.$store.commit('SET_NOTIFICATION', {
            'title': 'errors.' + e.response.data.errors[0].code,
            'type': 'error'
          })
        }
      })
    },
  }
}

</script>
<style lang="scss">

.lead-mask-update {

.field.is-optional label .optional{
  display: none;
}
}
textarea#structure{
  min-height: 10em;
}
.lead-mask-raw{
  margin-bottom: 24px;
  margin-top: 16px;
  .lead-mask-raw--title{
    font-size: 16px;
    color: #333;
    cursor: pointer;
    .icon{
      vertical-align: middle;
    }
  }
  .lead-mask-raw--content{
    padding: 10px;
    border: 1px solid #c9c9c9;
  }
}
.lead-mask-update{
  .tab--container{
    margin-top: 20px;
  }

}

#form-tabs {
  border-bottom: 0;
  background: $pastel-lighter;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 0 0px;
  display: flex;
  overflow-x: auto;
  height: 50px;
  .tab{
    padding: 20px;
    color: $pastel-dark;
    cursor: pointer;
    margin: 0 5px;
    font-size: 1.1em;
    &:first-child{
      margin-left: 0;
    }
    &.is-active{
      color: $onyx-light;
      padding-bottom: 5px;
      border: 0;
      background-color: #fff;
      border-radius: 4px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;

    }
  }
}


</style>



// WEBPACK FOOTER //
// LeadMaskUpdate.vue?2707a52a